export const websiteData = {
  companyName: "VIJAY INDUSTRY",
  tagline: "Strong Structures. Solid Futures.",
  taglineSecondary: "Complete Industrial & Structural Solutions",
  taglineTertiary: "For Residential, Commercial & Industrial Projects",
  contact: {
    phone: "9444833272",
    phoneDisplay: "+91 94448 33272",
    email: "vijayindustry.info@gmail.com",
    address: "Coimbatore, Tamil Nadu",
    googleMapsLink: "#",
    hours: "Monday - Saturday: 9:00 AM - 6:00 PM, Sunday: Closed"
  },
  services: [
    {
      id: "peb-buildings",
      section: "peb",
      title: "Pre-Engineered Buildings",
      categoryLabel: "PEB Structure",
      description: "Custom designed, high-strength pre-engineered steel buildings engineered for rapid installation and extreme structural durability.",
      icon: "Warehouse",
      image: "/images/pre_engineered.png",
      items: [
        "Custom Steel Framing",
        "High Structural Integrity",
        "Quick On-Site Assembly",
        "Clear Span Designs",
        "Weather Resistant Coating",
        "Scalable & Expandable"
      ]
    },
    {
      id: "peb-factory-sheds",
      section: "peb",
      title: "Factory Sheds",
      categoryLabel: "PEB Structure",
      description: "Spacious, heavy-duty industrial sheds engineered to host heavy factory operations, assembly lines, and crane installations.",
      icon: "Factory",
      image: "/images/factory.png",
      items: [
        "Crane Bracket Support",
        "Heavy-Duty Steel Roofs",
        "Optimal Ventilation",
        "Large Clear Spans",
        "Industrial Safety Standards",
        "Durable & Cost-Effective"
      ]
    },
    {
      id: "peb-warehouses",
      section: "peb",
      title: "Warehouses",
      categoryLabel: "PEB Structure",
      description: "Large-capacity, weather-proof steel warehouse structures built to optimize storage space and secure commercial inventory.",
      icon: "Archive",
      image: "/images/warehouse.png",
      items: [
        "Maximized Storage Space",
        "High Roof Clearance",
        "Multi-Point Loading Bays",
        "Fire-Retardant Panels",
        "Leak-Proof Sheeting",
        "Logistical Optimization"
      ]
    },
    {
      id: "peb-showrooms",
      section: "peb",
      title: "Showrooms",
      categoryLabel: "PEB Structure",
      description: "Modern, column-free commercial buildings featuring large open spans and glass frontages to elevate product displays.",
      icon: "Store",
      image: "/images/showrooms.png",
      items: [
        "Modern Aesthetics",
        "Large Glass Frontage",
        "Spacious Column-Free Layout",
        "Acoustic Insulation",
        "Energy Efficient Lighting",
        "Premium Interior Space"
      ]
    },
    {
      id: "peb-mezzanine",
      section: "peb",
      title: "Mezzanine Floors",
      categoryLabel: "PEB Structure",
      description: "Heavy-duty structural steel mezzanine floor systems designed to multiply storage or workspace within an existing footprint.",
      icon: "Layers",
      image: "/images/mezzanine-floors.png",
      items: [
        "Space Optimization",
        "High Load Capacity",
        "Integrated Safety Railings",
        "Staircase/Lift Access",
        "Modular Expandability",
        "Custom Height Options"
      ]
    },
    {
      id: "peb-cost-effective",
      section: "peb",
      title: "Durable & Cost Effective Solutions",
      categoryLabel: "PEB Structure",
      description: "Value-engineered structural solutions designed to minimize building maintenance and installation costs while maximizing life-span.",
      icon: "Coins",
      image: "/images/cost-effective-solutions.png",
      items: [
        "Low Maintenance Cost",
        "Long Operational Life",
        "Eco-Friendly Materials",
        "Fast Return on Investment",
        "High Resale Value",
        "All-Weather Protection"
      ]
    }
  ],
  whyChooseUs: [
    {
      title: "Durable & Strong",
      description: "Our structures are designed and engineered for extreme structural durability, strength, and decades of reliable use.",
      icon: "Shield"
    },
    {
      title: "Expert Team",
      description: "Skilled fabricators, structural engineers, and professional supervisors committed to flawless execution.",
      icon: "Users"
    },
    {
      title: "Quality Materials",
      description: "We use only premium, certified raw steel, roofing sheets, and SS grades to meet the highest industry standards.",
      icon: "Award"
    },
    {
      title: "Customer Satisfaction",
      description: "Clear communication, transparent quotes, on-time project completion, and continuous support.",
      icon: "ThumbsUp"
    }
  ],
  projects: [
    {
      id: 1,
      title: "Pre-Engineered Industrial Warehouse",
      category: "PEB Structures",
      description: "A 15,000 sq.ft. PEB warehouse structure featuring clear span framing and high roof clearance.",
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 2,
      title: "Manufacturing Unit Factory Shed",
      category: "PEB Structures",
      description: "Industrial PEB shed built with overhead crane brackets and integrated mezzanine office floor.",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1600&q=80"
    },
    {
      id: 3,
      title: "Industrial Roof Sheet Replacement",
      category: "Roofing",
      description: "Installation of durable premium blue coated profile roofing sheets over a commercial storage facility.",
      image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 4,
      title: "Leak-Proof Commercial Roofing Work",
      category: "Roofing",
      description: "High-grade profile sheeting with advanced weather insulation and leak-resistant joint seals.",
      image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 5,
      title: "Heavy MS Mezzanine Floor & Stairs",
      category: "MS Works",
      description: "Heavy structural steel mezzanine floor system with safety handrails and access staircase.",
      image: "https://images.unsplash.com/photo-1516216628859-9bccecab13ca?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 6,
      title: "Industrial Fabrication Steel Platform",
      category: "MS Works",
      description: "Custom mild steel equipment platforms and supportive structural frameworks for a processing unit.",
      image: "https://images.unsplash.com/photo-1516216628859-9bccecab13ca?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 7,
      title: "Modern Architectural SS Gate",
      category: "SS Works",
      description: "A premium grade 304 SS sliding gate with a minimalist geometric design for a commercial premises.",
      image: "https://images.unsplash.com/photo-1558036117-15d82a90b9b1?auto=format&fit=crop&w=1200&q=80"
    },
    {
      id: 8,
      title: "Polished SS Balcony & Staircase Handrails",
      category: "SS Works",
      description: "High-gloss mirror finish stainless steel safety railings for residential and commercial spaces.",
      image: "https://images.unsplash.com/photo-1558036117-15d82a90b9b1?auto=format&fit=crop&w=1200&q=80"
    }
  ]
};
